import React, { useLayoutEffect, useEffect, useRef, useState } from 'react';
import { select } from 'd3';
import * as d3 from 'd3';
import './style.css';

const D3LineChart = (props) => {
  const alphabet = props?.data;

  const chartRef = useRef(null);
  const ref = useRef(null);

  const [svgWidth, getSvgWidth] = useState();
  const [screenSize, getDimension] = useState({
    dynamicWidth: window.innerWidth
  });

  const setDimension = () => {
    getDimension({
      dynamicWidth: window.innerWidth
    });
  };

  useEffect(() => {
    window.addEventListener('resize', setDimension);

    return () => {
      window.removeEventListener('resize', setDimension);
    };
  }, [screenSize]);

  useEffect(() => {
    setTimeout(() => {
      getSvgWidth(ref?.current?.offsetWidth);
    }, 100);
  }, [screenSize]);

  useEffect(() => {
    d3.select(chartRef.current).select('svg').remove();
    const allValues = alphabet.flatMap(item => item.values.map(val => val.value));
    const highestValue = Math.max(...allValues);
    const xScaleData = alphabet.length ? alphabet[0]?.values : '';
    const container = d3.select(ref.current);
    const margin = { top: 50, right: 50, bottom: 50, left: 50 };
    const width = (container.node().getBoundingClientRect().width || svgWidth) - margin.left - margin.right;
    const height = 400 - margin.top - margin.bottom;

    const svg = d3
      .select(chartRef.current)
      .append('svg')
      .attr('width', width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom)
      .append('g')
      .attr('transform', `translate(${margin.left},${margin.top})`);

    const parseDate = d3.timeParse('%Y-%m-%dT%H:%M:%S.%L%Z');

    const x = d3
      .scaleTime()
      .domain(d3.extent(xScaleData, (d) => parseDate(d?.key)))
      .range([0, width]);

    const y = d3
      .scaleLinear()
      .domain([0, highestValue])
      .range([height, 0]);

    const line = d3
      .line()
      .x((d) => x(parseDate(d.key)))
      .y((d) => y(d.value))
      .curve(d3.curveMonotoneX);

    const colors = d3.schemeCategory10;

    alphabet.forEach((lineData, index) => {
      const lineGroup = svg.append('g');

    // Tooltip
    const tooltip = d3
      .select('body')
      .append('div.custom-d3tooltip')
      .style('position', 'absolute')
      .style('text-align', 'center')
      .style('padding', '2px')
      .style('font', '14px sans-serif')
      .style('background', 'transparent')
      .style('border', '0px')
      .style('pointer-events', 'none')
      .style('opacity', 0)
      .datum(lineData)
      .html((d) => d.name);

      lineGroup
        .append('path')
        .datum(lineData.values)
        .attr('fill', 'none')
        .attr('stroke', colors[index])
        .attr('stroke-width', 2)
        .attr('class', "path-line")
        .attr('d', line(lineData.values))
        .attr('cursor', 'pointer')
        .on('mouseover', function (d, i, e) {
          d3.selectAll(".path-line").attr('opacity', ".2");
          d3.selectAll(".dotn").attr('opacity', ".2");
          d3.select(this).attr('stroke-width', 2.5).attr('opacity', "1").transition().duration(500);
          tooltip.transition().duration(200).style('opacity', 0.9);
          tooltip.style('left', d.pageX + 10 + 'px')
          .style('top', d.pageY + 10 + 'px');
        })
        .on('mouseout', function (d, i, e) {
          d3.selectAll(".path-line").attr('opacity', "1");
          d3.selectAll(".dotn").attr('opacity', "1");
          d3.select(this).attr('stroke-width', 2).transition().duration(500);
          tooltip.transition().duration(500).style('opacity', 0);
        });

      lineGroup
        .selectAll('.bar-text')
        .data(lineData.values)
        .join('text')
        .attr('class', "bar-text")
        .attr('text-anchor', 'middle')
        .attr('font-family', '"Ericsson Hilda",Helvetica,sans-serif')
        .attr('font-size', '14px')
        .attr('font-weight', '700')
        .style('opacity', '0')
        .style('transition', '.3s')
        .style('display', 'none')
        .attr('x', (d) => x(parseDate(d.key)))
        .attr('y', (d) => y(d.value) - 14)
        .attr('id', (d, i) => 'bartextupper' + d.value.toString().replace('.', ''))
        .text((d) => d3.format(".3f")(d.value));

      lineGroup
        .append('g')
        .datum(lineData.values)
        .selectAll('.dotn')
        .data(lineData.values)
        .enter()
        .append('circle')
        .attr('class', 'dotn')
        .attr('cx', (d) => x(parseDate(d.key)))
        .attr('cy', (d) => y(d.value))
        .attr('r', 3)
        .attr('id', (d, i) => i)
        .attr('data-id', (d, i) => d.value.toString().replace('.', ''))
        .attr('cursor', 'pointer')
        .attr('fill', colors[index])
        .on('mouseover', function (d, i, e) {
          d3.select(this).attr('r', 5).transition().duration(500);
          const barUpperText = '#bartextupper' + d.target.dataset.id;
          d3.select(barUpperText).style('display', "block");
          d3.select(barUpperText).classed('active', true);
        })
        .on('mouseout', function (d, i, e) {
          d3.select(this).attr('r', 3).transition().duration(500);
          const barUpperText = '#bartextupper' + d.target.dataset.id;
          d3.select(barUpperText).style('display', "none");
          d3.select(barUpperText).classed('active', false);
        });
    });

    // const xAxis = d3.axisBottom(x);
    const xAxis = d3.axisBottom(x).tickFormat(d3.timeFormat("%b %d")).ticks(d3.timeWeek.every(1));
    const yAxis = d3.axisLeft(y).ticks(5).tickFormat((d) => d3.format(".2s")(d));
    svg.append('g').attr('transform', `translate(0, ${height})`).call(xAxis);
    svg.append('g').call(yAxis);
  }, [alphabet, svgWidth]);

  return (
    <>
      <div ref={ref} className="custom-line-chart w-100">
        <div className="w-100" ref={chartRef}></div>
      </div>
    </>
  );
};

export default D3LineChart;
